import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createContactWithoutBatch } from "api";
import { toastEmitter } from "components/Toast";

export default function useCreateContactWithoutBatch({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const queryclient = useQueryClient();

  const Request = useMutation({
    mutationFn: createContactWithoutBatch,
    mutationKey: ["createContactWithoutBatch"],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter("error", responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries(["contactLists"]);
      toastEmitter("success", responseData?.data?.message);
    },
  });
  return { ...Request };
}
